import "./orden_compra.css";
export { default as Listado } from "./Listado";
export { default as DetalleOC } from "./Detalle";
export { default as ReciboCuentaPagar } from "./ReciboCuentaPagar";
